import { Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HomeController } from '../../../controllers/home/home.controller';
import { UserRegisterWizardDto } from '@shared/src/dtos/register/UserRegisterWizardDto';

@Component({
  selector: 'register-want-to-work-with-you',
  templateUrl: './register-want-to-work-with-you.component.html',
  styleUrls: ['./register-want-to-work-with-you.component.scss']
})
export class RegisterWantToWorkWthYouComponent implements OnInit {

  public generalClass: string = "desktop";

  constructor(@Inject('HomeController') protected homecontroller: HomeController, private fb: FormBuilder) {
    if (this.homecontroller.getPlatform)
      this.generalClass = this.homecontroller.getPlatform();
  }

  ngOnInit() { }

  @Output()
  public onClickNext: EventEmitter<UserRegisterWizardDto> = new EventEmitter();

  @Input()
  public registerData: UserRegisterWizardDto = new UserRegisterWizardDto;

  @Input() 
  public pendigResponse: boolean;

  next() {
    if(this.pendigResponse)
      return;
    this.onClickNext.next(this.registerData);
  }

  public pretty(value: any): string {
    return JSON.stringify(value);
  }
}
